import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.41,16.59l-14-14A1.966,1.966,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V14a1.966,1.966,0,0,0,.59,1.41l14,14a1.98,1.98,0,0,0,2.82,0l10-10A1.974,1.974,0,0,0,29.41,16.59ZM4,4H14L28,18,18,28,4,14Z"/><circle cx="10" cy="10" r="2"/>';
export var TagOutlineSVG = function TagOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TagOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TagOutlineSVG);